import { Link } from "react-router-dom";
import styles from "./Footer.module.css";
import { useTranslation } from "react-i18next";

import logoMKiDN from "../../assets/logoMKiDN-dark.svg";
import logoNIFC from "../../assets/logoNIFC.jpg";
import logoPWr from "../../assets/logoPWr.png";
import logoUwr from "../../assets/logoUwr.png";
import logoWIT from "../../assets/logoWIT.png";
import logoChopin from "../../assets/logoChopinFooter.png";
export default function Footer() {
    const { t } = useTranslation();

    // Configure external links for logos here. Set to null to render as non-clickable.
    const LINKS = {
        MKiDN: "https://www.gov.pl/kultura",
        CHOPIN: "https://nifc.pl/",
        UWR: "https://uwr.edu.pl/",
        PWR: "https://pwr.edu.pl/",
        WIT: "https://wit.pwr.edu.pl/",
    };

    const Logo = ({ src, alt, className, href, title }) => {
        const img = <img src={src} alt={alt} className={className} title={title || alt} />;
        return href
            ? (
                <a href={href} target="_blank" rel="noopener noreferrer" className={styles.logoLink} aria-label={alt} title={title || alt}>
                    {img}
                </a>
            )
            : img;
    };

    return (
        <footer className={styles.footer}>
            <div className={styles.left}>
                <div className={styles.logosGrid}>
                    <div className={styles.rowTop}>
                        <div className={styles.sponsorMain}>
                            <Logo src={logoMKiDN} alt="MKiDN" className={styles.mainLogo} href={LINKS.MKiDN} />
                        </div>
                        <div className={styles.textArea}>
                            <p className={styles.supportText}>
                                {t("footer.supportText", { defaultValue: "Projekt współfinansowany ze środków MKiDN oraz realizowany we współpracy z partnerami." })}
                            </p>
                        </div>
                    </div>
                    <div className={styles.rowBottom}>
                        <Logo src={logoChopin} alt="Chopin" className={styles.logoImg} href={LINKS.CHOPIN} />
                        <Logo src={logoUwr} alt="UWr" className={styles.logoImg} href={LINKS.UWR} />
                        <Logo src={logoPWr} alt="PWr" className={styles.logoImg} href={LINKS.PWR} />
                        <Logo src={logoWIT} alt="WIT" className={styles.logoImg} href={LINKS.WIT} />
                    </div>
                </div>
            </div>
        </footer>
    );
}